import { useFormContext } from 'react-hook-form';
import { Card } from '@shared/ui';
import { PaymentMethod } from '@shared/ui/inputs/payment-method';
import { getErrorMessages } from '@src/library/helpers/events/errorMessages';
import { CustomEditorInputControlled } from '@src/modules/Authentication/InputsControlled';
import * as st from './styles.module.scss';

export const Cost = (): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = getErrorMessages(errors, ['cost', 'cost_payment_method']).join(' ');

  return (
    <fieldset>
      <div className={st.header}>
        <h3>Стоимость</h3>
        <p>{errorMessage}</p>
      </div>
      <Card className={st.cost}>
        <div className={st.wrapper}>
          <div className={st.cost__input}>
            <CustomEditorInputControlled control={control} name="cost" label="" sufix={'RUB'} />
          </div>
          <PaymentMethod fieldName="cost_payment_method" />
        </div>
      </Card>
    </fieldset>
  );
};
